module.exports = __webpack_public_path__ + "static/media/Right AP Z1.1a7b0a12.png";